import React from 'react'
import './bgOverlay.scss'

const bgOverlay = props => (
    <div className="wd-bg-overlay" onClick={props.click}/>
);

export default bgOverlay